import React, { useState, useEffect } from 'react';
import axios from 'axios';
import * as XLSX from 'xlsx';
import './Envase.css';

const API_URL = '/api/empleados';

const obtenerFechaHoy = () => new Date().toISOString().split('T')[0];

const formularioInicial = {
    idEmpleado: '',
    nombre: '',
    direccion: '',
    pais: '',
    lugarnacim: 0,
    fchnacimiento: '',
    sexo: '',
    estadocivil: '',
    ciudad: null,
    barrio: '',
    telefono: '',
    tipodocident: 1,
    docidentidad: 0,
    cedulamilitar: 0,
    titacademico: 0,
    profesion: 0,
    sucursal: 1,
    turno: 1,
    depto: 1,
    cargo: 0,
    formapago: 'M',
    fechaingreso: obtenerFechaHoy(),
    fechaips: '',
    sueldo: 0,
    sueldoadic: 0,
    codseguropriv: 0,
    nroseguropriv: 0,
    monseguropriv: 0,
    nroseguroips: 0,
    banco: 0,
    ctabanco: 0,
    categoria: 'E',
    estadoactiv: 'A',
    esjubilado: 'N',
    cobraextra: 'N',
    cobracomision: 'N',
    canhijos: 0,
    fechasalida: '',
    tipoempleado: 'N',
    sueldoant: 0,
    obs: '',
    idEmpresa: 1,
    estado: 'A'
};

function JEmpleado() {
    const [empleados, setEmpleados] = useState([]);
    const [filtro, setFiltro] = useState('');
    const [modalAbierto, setModalAbierto] = useState(false);
    const [modoEdicion, setModoEdicion] = useState(false);
    const [formulario, setFormulario] = useState(formularioInicial);
    const [pagina, setPagina] = useState(1);
    const [porPagina, setPorPagina] = useState(10);

    useEffect(() => { cargar(); }, []);

    const cargar = async () => {
        try {
            const r = await axios.get(API_URL);
            setEmpleados(r.data);
        } catch (e) {
            console.error('Error al cargar empleados:', e);
            alert('Error al cargar empleados');
        }
    };

    const abrirModalNuevo = async () => {
        setModoEdicion(false);
        try {
            const r = await axios.get(`${API_URL}/proximo-id`);
            setFormulario({ ...formularioInicial, idEmpleado: r.data });
        } catch (e) {
            console.error('Error al obtener proximo id:', e);
            setFormulario(formularioInicial);
        }
        setModalAbierto(true);
    };

    const abrirModalEditar = (emp) => {
        setModoEdicion(true);
        setFormulario({
            ...formularioInicial,
            ...emp,
            fchnacimiento: emp.fchnacimiento || '',
            fechaingreso: emp.fechaingreso || obtenerFechaHoy(),
            fechaips: emp.fechaips || '',
            fechasalida: emp.fechasalida || '',
            pais: emp.pais || '',
            sexo: emp.sexo || '',
            estadocivil: emp.estadocivil || '',
            barrio: emp.barrio || ''
        });
        setModalAbierto(true);
    };

    const cerrarModal = () => setModalAbierto(false);

    const handleChange = (e) => {
        const { name, value, type } = e.target;
        setFormulario(prev => ({
            ...prev,
            [name]: type === 'number' ? (value === '' ? '' : Number(value)) : value
        }));
    };

    const limpiarFechas = (payload) => ({
        ...payload,
        fchnacimiento: payload.fchnacimiento || null,
        fechaingreso: payload.fechaingreso || null,
        fechaips: payload.fechaips || null,
        fechasalida: payload.fechasalida || null,
        ciudad: payload.ciudad === '' ? null : payload.ciudad
    });

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!formulario.nombre) { alert('Nombre es obligatorio'); return; }

        try {
            const payload = limpiarFechas(formulario);
            if (modoEdicion) {
                await axios.put(`${API_URL}/${formulario.idEmpleado}`, payload);
                alert('Empleado actualizado');
            } else {
                await axios.post(API_URL, payload);
                alert('Empleado creado con ID ' + payload.idEmpleado);
            }
            await cargar();
            cerrarModal();
        } catch (error) {
            const msg = error.response?.data || 'Error al guardar';
            alert(typeof msg === 'string' ? msg : 'Error al guardar');
        }
    };

    const inactivar = async (emp) => {
        if (emp.estado === 'I') { alert('El empleado ya esta inactivo'); return; }
        if (!window.confirm(`Inactivar al empleado ${emp.nombre} (ID ${emp.idEmpleado})?`)) return;
        try {
            await axios.put(`${API_URL}/${emp.idEmpleado}/inactivar`);
            alert('Empleado inactivado');
            cargar();
        } catch (error) {
            const msg = error.response?.data || 'Error al inactivar';
            alert(typeof msg === 'string' ? msg : 'Error al inactivar');
        }
    };

    const reactivar = async (emp) => {
        if (emp.estado === 'A') { alert('El empleado ya esta activo'); return; }
        if (!window.confirm(`Reactivar al empleado ${emp.nombre}?`)) return;
        try {
            await axios.put(`${API_URL}/${emp.idEmpleado}/reactivar`);
            alert('Empleado reactivado');
            cargar();
        } catch (error) {
            const msg = error.response?.data || 'Error al reactivar';
            alert(typeof msg === 'string' ? msg : 'Error al reactivar');
        }
    };

    const exportarExcel = () => {
        if (empleados.length === 0) {
            alert('No hay empleados para exportar');
            return;
        }
        // Exportar TODOS los empleados (no aplica filtro ni paginacion)
        const datos = empleados.map(e => ({
            'ID Empleado': e.idEmpleado,
            'Nombre': e.nombre,
            'Sexo': e.sexo === 'M' ? 'Masculino' : e.sexo === 'F' ? 'Femenino' : '',
            'Estado Civil': e.estadocivil,
            'Fecha Nacimiento': e.fchnacimiento,
            'Direccion': e.direccion,
            'Barrio': e.barrio,
            'Telefono': e.telefono,
            'Pais': e.pais,
            'Ciudad': e.ciudad,
            'Doc. Identidad': e.docidentidad,
            'Ced. Militar': e.cedulamilitar,
            'Sucursal': e.sucursal,
            'Depto': e.depto,
            'Cargo': e.cargo,
            'Turno': e.turno,
            'Fecha Ingreso': e.fechaingreso,
            'Fecha IPS': e.fechaips,
            'Fecha Salida': e.fechasalida,
            'Categoria': e.categoria,
            'Estado Activ': e.estadoactiv,
            'Tipo Empleado': e.tipoempleado,
            'Es Jubilado': e.esjubilado,
            'Cant. Hijos': e.canhijos,
            'Sueldo': e.sueldo,
            'Sueldo Adicional': e.sueldoadic,
            'Sueldo Anterior': e.sueldoant,
            'Forma Pago': e.formapago,
            'Cobra Extra': e.cobraextra,
            'Cobra Comision': e.cobracomision,
            'Banco': e.banco,
            'Cta. Banco': e.ctabanco,
            'Cod. Seguro Priv.': e.codseguropriv,
            'Nro. Seguro Priv.': e.nroseguropriv,
            'Monto Seguro Priv.': e.monseguropriv,
            'Nro. Seguro IPS': e.nroseguroips,
            'Tit. Academico': e.titacademico,
            'Profesion': e.profesion,
            'Tipo Doc. Ident.': e.tipodocident,
            'Lugar Nacim.': e.lugarnacim,
            'ID Empresa': e.idEmpresa,
            'Estado': e.estado === 'A' ? 'Activo' : 'Inactivo',
            'Observaciones': e.obs,
            'Fecha Ult. Movim.': e.fchultmovim
        }));

        const worksheet = XLSX.utils.json_to_sheet(datos);

        // Ajustar ancho de columnas segun el contenido
        const anchoCols = Object.keys(datos[0]).map(k => ({
            wch: Math.max(k.length, 12)
        }));
        worksheet['!cols'] = anchoCols;

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Empleados');

        const fecha = new Date().toISOString().split('T')[0];
        XLSX.writeFile(workbook, `empleados_${fecha}.xlsx`);
    };

    const filtrados = empleados.filter(e =>
        !filtro ||
        e.nombre?.toLowerCase().includes(filtro.toLowerCase()) ||
        e.idEmpleado?.toString().includes(filtro) ||
        e.telefono?.includes(filtro)
    );

    const totalPaginas = Math.max(1, Math.ceil(filtrados.length / porPagina));
    const inicio = (pagina - 1) * porPagina;
    const paginados = filtrados.slice(inicio, inicio + porPagina);

    return (
        <div className="envase-container">
            <div className="header-seccion">
                <h2>Colaboradores</h2>
                <div className="acciones-header">
                    <input
                        type="text"
                        placeholder="Buscar..."
                        value={filtro}
                        onChange={(e) => { setFiltro(e.target.value); setPagina(1); }}
                        className="input-busqueda"
                    />
                    <button onClick={abrirModalNuevo} className="btn btn-nuevo">
                        ➕ Nuevo
                    </button>
                    <button onClick={exportarExcel} className="btn btn-exportar">
                        📊 Exportar Excel
                    </button>
                </div>
            </div>

            <div className="tabla-container">
                <table className="tabla-datos">
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Nombre</th>
                            <th>Telefono</th>
                            <th>Direccion</th>
                            <th>Categoria</th>
                            <th>Estado Activ.</th>
                            <th>Estado</th>
                            <th>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {paginados.length === 0 ? (
                            <tr><td colSpan="8" className="sin-datos">No hay empleados para mostrar</td></tr>
                        ) : paginados.map(emp => (
                            <tr key={emp.idEmpleado} style={emp.estado === 'I' ? { opacity: 0.5 } : {}}>
                                <td>{emp.idEmpleado}</td>
                                <td>{emp.nombre}</td>
                                <td>{emp.telefono}</td>
                                <td>{emp.direccion}</td>
                                <td>{emp.categoria}</td>
                                <td>{emp.estadoactiv}</td>
                                <td>{emp.estado === 'A' ? 'Activo' : 'Inactivo'}</td>
                                <td>
                                    <button onClick={() => abrirModalEditar(emp)} className="btn-accion" title="Editar">✏️</button>
                                    {emp.estado === 'A' ? (
                                        <button onClick={() => inactivar(emp)} className="btn-accion"
                                            title="Inactivar" style={{ color: '#d97706' }}>🚫</button>
                                    ) : (
                                        <button onClick={() => reactivar(emp)} className="btn-accion"
                                            title="Reactivar" style={{ color: '#059669' }}>✓</button>
                                    )}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {/* Paginacion */}
            <div className="paginacion-container">
                <div className="paginacion-info">
                    <span>Mostrando {filtrados.length > 0 ? inicio + 1 : 0} a {Math.min(inicio + porPagina, filtrados.length)} de {filtrados.length}</span>
                    <select value={porPagina} onChange={(e) => { setPorPagina(Number(e.target.value)); setPagina(1); }} className="select-registros">
                        <option value={10}>10</option><option value={20}>20</option><option value={50}>50</option>
                    </select>
                </div>
                <div className="paginacion-controles">
                    <button onClick={() => setPagina(1)} disabled={pagina === 1} className="btn-paginacion">|&lt;</button>
                    <button onClick={() => setPagina(p => p - 1)} disabled={pagina === 1} className="btn-paginacion">&lt;</button>
                    <span className="paginacion-numero">{pagina} / {totalPaginas}</span>
                    <button onClick={() => setPagina(p => p + 1)} disabled={pagina >= totalPaginas} className="btn-paginacion">&gt;</button>
                    <button onClick={() => setPagina(totalPaginas)} disabled={pagina >= totalPaginas} className="btn-paginacion">&gt;|</button>
                </div>
            </div>

            {/* Modal */}
            {modalAbierto && (
                <div className="atm-modal-overlay" onClick={cerrarModal}>
                    <div className="atm-modal atm-modal-lg" onClick={(e) => e.stopPropagation()}>
                        <div className="atm-modal-header">
                            <h3>{modoEdicion ? 'Editar Empleado' : 'Nuevo Empleado'}</h3>
                            <button onClick={cerrarModal} className="atm-modal-close">×</button>
                        </div>
                        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', flex: 1, overflow: 'hidden' }}>
                            <div className="atm-modal-body">

                                {/* Datos personales */}
                                <div style={{ marginBottom: '20px', padding: '12px', border: '1px solid #e0e0e0', borderRadius: '6px', backgroundColor: '#fafafa' }}>
                                    <h4 style={{ margin: '0 0 10px 0', color: '#001A70', borderBottom: '2px solid #001A70', paddingBottom: '5px' }}>Datos Personales</h4>
                                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 2fr 1fr 1fr', gap: '10px' }}>
                                        <div className="form-group">
                                            <label>ID Empleado</label>
                                            <input type="number" name="idEmpleado" value={formulario.idEmpleado}
                                                readOnly tabIndex={-1}
                                                style={{ backgroundColor: '#f0f0f0', cursor: 'not-allowed' }}
                                                placeholder="Auto" />
                                        </div>
                                        <div className="form-group">
                                            <label>Nombre *</label>
                                            <input type="text" name="nombre" value={formulario.nombre}
                                                onChange={handleChange} maxLength={40} required />
                                        </div>
                                        <div className="form-group">
                                            <label>Sexo</label>
                                            <select name="sexo" value={formulario.sexo} onChange={handleChange}>
                                                <option value="">-</option>
                                                <option value="M">Masculino</option>
                                                <option value="F">Femenino</option>
                                            </select>
                                        </div>
                                        <div className="form-group">
                                            <label>Estado Civil</label>
                                            <select name="estadocivil" value={formulario.estadocivil} onChange={handleChange}>
                                                <option value="">-</option>
                                                <option value="S">Soltero/a</option>
                                                <option value="C">Casado/a</option>
                                                <option value="V">Viudo/a</option>
                                                <option value="D">Divorciado/a</option>
                                                <option value="P">Union libre</option>
                                                <option value="O">Otro</option>
                                            </select>
                                        </div>
                                        <div className="form-group">
                                            <label>Fecha Nacimiento</label>
                                            <input type="date" name="fchnacimiento" value={formulario.fchnacimiento || ''} onChange={handleChange} />
                                        </div>
                                        <div className="form-group">
                                            <label>Direccion</label>
                                            <input type="text" name="direccion" value={formulario.direccion} onChange={handleChange} maxLength={40} />
                                        </div>
                                        <div className="form-group">
                                            <label>Barrio</label>
                                            <input type="text" name="barrio" value={formulario.barrio} onChange={handleChange} maxLength={20} />
                                        </div>
                                        <div className="form-group">
                                            <label>Telefono</label>
                                            <input type="text" name="telefono" value={formulario.telefono} onChange={handleChange} maxLength={20} />
                                        </div>
                                        <div className="form-group">
                                            <label>Pais</label>
                                            <input type="text" name="pais" value={formulario.pais} onChange={handleChange} maxLength={2} placeholder="PY" />
                                        </div>
                                        <div className="form-group">
                                            <label>Ciudad (ID)</label>
                                            <input type="number" name="ciudad" value={formulario.ciudad || ''} onChange={handleChange} />
                                        </div>
                                        <div className="form-group">
                                            <label>Doc. Identidad</label>
                                            <input type="number" name="docidentidad" value={formulario.docidentidad} onChange={handleChange} />
                                        </div>
                                        <div className="form-group">
                                            <label>Ced. Militar</label>
                                            <input type="number" name="cedulamilitar" value={formulario.cedulamilitar} onChange={handleChange} />
                                        </div>
                                    </div>
                                </div>

                                {/* Datos laborales */}
                                <div style={{ marginBottom: '20px', padding: '12px', border: '1px solid #e0e0e0', borderRadius: '6px', backgroundColor: '#fafafa' }}>
                                    <h4 style={{ margin: '0 0 10px 0', color: '#001A70', borderBottom: '2px solid #001A70', paddingBottom: '5px' }}>Datos Laborales</h4>
                                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr', gap: '10px' }}>
                                        <div className="form-group">
                                            <label>Sucursal (ID)</label>
                                            <input type="number" name="sucursal" value={formulario.sucursal} onChange={handleChange} />
                                        </div>
                                        <div className="form-group">
                                            <label>Depto (ID)</label>
                                            <input type="number" name="depto" value={formulario.depto} onChange={handleChange} />
                                        </div>
                                        <div className="form-group">
                                            <label>Cargo (ID)</label>
                                            <input type="number" name="cargo" value={formulario.cargo} onChange={handleChange} />
                                        </div>
                                        <div className="form-group">
                                            <label>Turno</label>
                                            <input type="number" name="turno" value={formulario.turno} onChange={handleChange} />
                                        </div>
                                        <div className="form-group">
                                            <label>Fecha Ingreso</label>
                                            <input type="date" name="fechaingreso" value={formulario.fechaingreso || ''} onChange={handleChange} />
                                        </div>
                                        <div className="form-group">
                                            <label>Fecha IPS</label>
                                            <input type="date" name="fechaips" value={formulario.fechaips || ''} onChange={handleChange} />
                                        </div>
                                        <div className="form-group">
                                            <label>Fecha Salida</label>
                                            <input type="date" name="fechasalida" value={formulario.fechasalida || ''} onChange={handleChange} />
                                        </div>
                                        <div className="form-group">
                                            <label>Categoria</label>
                                            <select name="categoria" value={formulario.categoria} onChange={handleChange}>
                                                <option value="E">Empleado</option>
                                                <option value="D">Directivo</option>
                                                <option value="J">Jubilado</option>
                                                <option value="O">Otro</option>
                                            </select>
                                        </div>
                                        <div className="form-group">
                                            <label>Estado Activ.</label>
                                            <select name="estadoactiv" value={formulario.estadoactiv} onChange={handleChange}>
                                                <option value="A">Activo</option>
                                                <option value="P">Permiso</option>
                                                <option value="V">Vacaciones</option>
                                                <option value="R">Retirado</option>
                                                <option value="D">Despedido</option>
                                            </select>
                                        </div>
                                        <div className="form-group">
                                            <label>Tipo Empleado</label>
                                            <select name="tipoempleado" value={formulario.tipoempleado} onChange={handleChange}>
                                                <option value="N">Normal</option>
                                                <option value="P">Practicante</option>
                                            </select>
                                        </div>
                                        <div className="form-group">
                                            <label>Es Jubilado?</label>
                                            <select name="esjubilado" value={formulario.esjubilado} onChange={handleChange}>
                                                <option value="N">No</option>
                                                <option value="S">Si</option>
                                            </select>
                                        </div>
                                        <div className="form-group">
                                            <label>Cant. Hijos</label>
                                            <input type="number" name="canhijos" value={formulario.canhijos} onChange={handleChange} />
                                        </div>
                                    </div>
                                </div>

                                {/* Sueldo y pagos */}
                                <div style={{ marginBottom: '20px', padding: '12px', border: '1px solid #e0e0e0', borderRadius: '6px', backgroundColor: '#fafafa' }}>
                                    <h4 style={{ margin: '0 0 10px 0', color: '#001A70', borderBottom: '2px solid #001A70', paddingBottom: '5px' }}>Sueldo y Pagos</h4>
                                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr', gap: '10px' }}>
                                        <div className="form-group">
                                            <label>Sueldo</label>
                                            <input type="number" name="sueldo" value={formulario.sueldo} onChange={handleChange} />
                                        </div>
                                        <div className="form-group">
                                            <label>Sueldo Adicional</label>
                                            <input type="number" name="sueldoadic" value={formulario.sueldoadic} onChange={handleChange} />
                                        </div>
                                        <div className="form-group">
                                            <label>Sueldo Anterior</label>
                                            <input type="number" name="sueldoant" value={formulario.sueldoant} onChange={handleChange} />
                                        </div>
                                        <div className="form-group">
                                            <label>Forma de Pago</label>
                                            <select name="formapago" value={formulario.formapago} onChange={handleChange}>
                                                <option value="M">Mensual</option>
                                                <option value="Q">Quincenal</option>
                                                <option value="S">Semanal</option>
                                                <option value="D">Diario</option>
                                            </select>
                                        </div>
                                        <div className="form-group">
                                            <label>Cobra Extras?</label>
                                            <select name="cobraextra" value={formulario.cobraextra} onChange={handleChange}>
                                                <option value="N">No</option>
                                                <option value="S">Si</option>
                                            </select>
                                        </div>
                                        <div className="form-group">
                                            <label>Cobra Comision?</label>
                                            <select name="cobracomision" value={formulario.cobracomision} onChange={handleChange}>
                                                <option value="N">No</option>
                                                <option value="S">Si</option>
                                            </select>
                                        </div>
                                        <div className="form-group">
                                            <label>Banco (ID)</label>
                                            <input type="number" name="banco" value={formulario.banco} onChange={handleChange} />
                                        </div>
                                        <div className="form-group">
                                            <label>Cta. Banco</label>
                                            <input type="number" name="ctabanco" value={formulario.ctabanco} onChange={handleChange} />
                                        </div>
                                    </div>
                                </div>

                                {/* Seguro */}
                                <div style={{ marginBottom: '20px', padding: '12px', border: '1px solid #e0e0e0', borderRadius: '6px', backgroundColor: '#fafafa' }}>
                                    <h4 style={{ margin: '0 0 10px 0', color: '#001A70', borderBottom: '2px solid #001A70', paddingBottom: '5px' }}>Seguro y Otros</h4>
                                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr', gap: '10px' }}>
                                        <div className="form-group">
                                            <label>Cod. Seguro Priv.</label>
                                            <input type="number" name="codseguropriv" value={formulario.codseguropriv} onChange={handleChange} />
                                        </div>
                                        <div className="form-group">
                                            <label>Nro. Seguro Priv.</label>
                                            <input type="number" name="nroseguropriv" value={formulario.nroseguropriv} onChange={handleChange} />
                                        </div>
                                        <div className="form-group">
                                            <label>Monto Seguro Priv.</label>
                                            <input type="number" name="monseguropriv" value={formulario.monseguropriv} onChange={handleChange} />
                                        </div>
                                        <div className="form-group">
                                            <label>Nro. Seguro IPS</label>
                                            <input type="number" name="nroseguroips" value={formulario.nroseguroips} onChange={handleChange} />
                                        </div>
                                        <div className="form-group">
                                            <label>Tit. Academico (ID)</label>
                                            <input type="number" name="titacademico" value={formulario.titacademico} onChange={handleChange} />
                                        </div>
                                        <div className="form-group">
                                            <label>Profesion (ID)</label>
                                            <input type="number" name="profesion" value={formulario.profesion} onChange={handleChange} />
                                        </div>
                                        <div className="form-group">
                                            <label>Tipo Doc. Ident.</label>
                                            <input type="number" name="tipodocident" value={formulario.tipodocident} onChange={handleChange} />
                                        </div>
                                        <div className="form-group">
                                            <label>Lugar Nacim. (ID)</label>
                                            <input type="number" name="lugarnacim" value={formulario.lugarnacim} onChange={handleChange} />
                                        </div>
                                    </div>
                                </div>

                                {/* Observaciones */}
                                <div style={{ marginBottom: '10px', padding: '12px', border: '1px solid #e0e0e0', borderRadius: '6px', backgroundColor: '#fafafa' }}>
                                    <h4 style={{ margin: '0 0 10px 0', color: '#001A70', borderBottom: '2px solid #001A70', paddingBottom: '5px' }}>Observaciones</h4>
                                    <div className="form-group">
                                        <textarea name="obs" value={formulario.obs || ''} onChange={handleChange}
                                            maxLength={1000} rows={3}
                                            style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '5px' }} />
                                    </div>
                                </div>

                            </div>
                            <div className="atm-modal-footer">
                                <button type="button" onClick={cerrarModal} className="atm-btn-cancelar">Cancelar</button>
                                <button type="submit" className="atm-btn-primary">{modoEdicion ? 'Actualizar' : 'Crear'}</button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
}

export default JEmpleado;
